import { IMessageType } from '@/services/signalr/types';
import { IProQACaseRequestMsg } from '~/api/messages/IProQaCaseReqMsg';
import { IProQaRunStatusReqMsg } from '~/api/messages/IProQaRunStatusReqMsg';
import { IProQaRunStatusRespMsg } from '~/api/messages/IProQaRunStatusRespMsg';
import { IProQaTripReqMsg } from '~/api/messages/IProQaTripReqMsg';
import { IProQaTripRespMsg } from '~/api/messages/IProQaTripRespMsg';

export const ProQaCaseReqMsg: IMessageType<IProQACaseRequestMsg> = {
  requestName: 'ProQACaseRequestMsg',
};

export const ProQaTripReqMsg: IMessageType<IProQaTripReqMsg, IProQaTripRespMsg> = {
  requestName: 'ProQaTripReqMsg',
  responseName: 'ProQaTripMsg',
};

export const ProQaRunStatusReqMsg: IMessageType<IProQaRunStatusReqMsg, IProQaRunStatusRespMsg> = {
  requestName: 'ProQaRunStatusReqMsg',
  responseName: 'ProQaRunStatusRespMsg',
};
